module.exports = __webpack_public_path__ + "img/spinner.7095dd29.gif";